import { ErrorFault } from "models/ErrorFault";
import IApiClient from "./ApiClient";

export interface ILogService {
    postLog(log: ErrorFault): void;
  }

export default class LogService implements ILogService{
    apiBase: string;
    apiClient: IApiClient;
  
    constructor(apiClient: IApiClient) {
      this.apiBase = '/api/log';
      this.apiClient = apiClient;
    }
  
    async postLog(log: ErrorFault) {
        try {
          await this.apiClient.post<ErrorFault, null>(`${this.apiBase}/error`, log);
        } catch (exception) {
          console.error(exception);
        }
      }
  }